const API_KEY = "MONFVUjXryQt1FfSUnAsGZtGtbdecG4u";

export default API_KEY;